import AbstractService from '@/services/abstractService'

class PhaseTwoService extends AbstractService {
    endpoint = 'projects'

    post(id, data) {
      console.log('dataaaaaa', data)

      const formData = new FormData()
      for (const key in data) {
        if (key === 'designTypes') {
          for (let item = 0; item < data.designTypes.length; item++) {
            for (const k in data.designTypes[item]) {
              if (k === 'uploaded') {
                data.designTypes[item][k].forEach((el, idx) => {
                  formData.append(`${key}[${item}][${k}][${idx}]`, el) // designTypes[1][uploaded][1] {array: (0,1,2,3,4,5)}
                })
                if (data.designTypes[item][k].length === 0) formData.append(`${key}[${item}][${k}][]`, [])
              } else if (k === 'remained') {
                data.designTypes[item][k].forEach((el, idx) => {
                  formData.append(`${key}[${item}][${k}][${idx}]`, el) // designTypes[1][uploaded][1] {array: (0,1,2,3,4,5)}
                })
                if (data.designTypes[item][k].length === 0) formData.append(`${key}[${item}][${k}][]`, [])
              } else {
                formData.append(`${key}[${item}][${k}]`, data.designTypes[item][k])
              }
            }
          }
        } else if (key === 'revisions') {
          console.log('k  uploaded:: ', data.revisions)

          for (const k in data.revisions) {
            console.log('kkkk', k)
            if (k === 'uploaded') {
              if (data.revisions.uploaded.length > 0) {
                for (let item = 0; item < data.revisions.uploaded.length; item++) {
                  formData.append(`${key}[${k}][${item}]`, data.revisions.uploaded[item])
                }
              } else {
                formData.append(`${key}[uploaded][]`, [])
              }
            } else {
              console.log('k  remained:: ', k)
              console.log('k  uploaded:: ', data.revisions.remained)
              if (data.revisions.remained.length > 0) {
                for (let item = 0; item < data.revisions.remained.length; item++) {
                  formData.append(`${key}[${k}][${item}]`, data.revisions.remained[item])
                }
              } else {
                formData.append(`${key}[remained][]`, [])
              }
            }
          }
        } else if (data[key] !== null) {
          formData.append(key, data[key])
        } else {
          formData.append(key, '')
        }
      }
      return this.http.post(`${this.endpoint}/${id}/phase2`, formData)

      // return this.http.post(`${this.endpoint}/${data.id}`, formData)
    }

    delete(data) {
      return this.http.delete(`${this.endpoint}/media/${data}`)
    }
}

const Service = new PhaseTwoService()

export default Service
